import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msalConfig";

// Returns a fetch wrapper that automatically attaches the Bearer token
export function useApiClient(): { get: (path: string) => Promise<Response>; post: (path: string, body: unknown) => Promise<Response>; put: (path: string, body: unknown) => Promise<Response>; patch: (path: string, body: unknown) => Promise<Response>; del: (path: string) => Promise<Response> } {
  const { instance, accounts } = useMsal();

  async function getToken(): Promise<string> {
    const account = accounts[0];
    if (!account) throw new Error("No authenticated account");

    const result = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return result.accessToken;
  }

  const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4000";

  async function request(method: string, path: string, body?: unknown): Promise<Response> {
    const token = await getToken();
    return fetch(`${baseUrl}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  }

  return {
    get: (path: string) => request("GET", path),
    post: (path: string, body: unknown) => request("POST", path, body),
    put: (path: string, body: unknown) => request("PUT", path, body),
    patch: (path: string, body: unknown) => request("PATCH", path, body),
    del: (path: string) => request("DELETE", path),
  };
}
